import {EventEmitter} from 'fbemitter'

const emitter = new EventEmitter();

export default emitter;


// WEBPACK FOOTER //
// ./src/base/event/emitter.js